import { useScannerContext } from '@/contexts/ScannerContext';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Radio } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NFCConnectionIndicatorProps {
  showLabel?: boolean;
  className?: string;
}

export function NFCConnectionIndicator({ showLabel = false, className }: NFCConnectionIndicatorProps) {
  const { nfcBridge, reconnect } = useScannerContext();
  const { isReaderReady, isConnecting } = nfcBridge;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          onClick={reconnect}
          className={cn(
            "flex items-center gap-2 px-2 py-1 rounded-md transition-colors hover:bg-accent/10",
            className
          )}
        >
          <div className="relative">
            <Radio
              className={cn(
                "w-4 h-4 transition-colors",
                isReaderReady ? "text-green-500" : "text-muted-foreground"
              )}
            />
            {isReaderReady && (
              <span className="absolute -top-0.5 -right-0.5 flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
              </span>
            )}
            {isConnecting && (
              <span className="absolute -top-0.5 -right-0.5 flex h-2 w-2">
                <span className="animate-pulse relative inline-flex rounded-full h-2 w-2 bg-yellow-500"></span>
              </span>
            )}
          </div>
          {showLabel && (
            <span className={cn(
              "text-xs",
              isReaderReady ? "text-green-500" : "text-muted-foreground"
            )}>
              {isReaderReady ? "NFC Conectado" : isConnecting ? "Conectando..." : "NFC"}
            </span>
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent side="bottom">
        <p>
          {isReaderReady
            ? "Lector NFC conectado - Click para reconectar"
            : isConnecting
              ? "Conectando al lector NFC..."
              : "Lector NFC no disponible - Click para reintentar"
          }
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
